var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tab-title',[_vm._v("Location")]),_c('tab-content',[(!_vm.offerBarred)?_c('google-static-map',{attrs:{"location":_vm.offer.gig.location}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }